import { serviceAgreementApi } from 'api';
import type { LinkedContactNote } from 'views/PrivateBanking/LinkedContactNotesGrid';
import { toLinkedContactNote } from 'views/PrivateBanking/mappers/contactNoteMapper';

export const getContactNotesApi = async (serviceAgreementUid: string): Promise<LinkedContactNote[]> => {
  const response = await serviceAgreementApi.getServiceAgreementContactNotes({ serviceAgreementUid });

  return (response.contactNotes ?? []).map(toLinkedContactNote);
};
